import React from "react";
import { X } from "lucide-react";
import { marqueeTopItems, marqueeBottomItems } from "../mock";

const Band = ({ items, dark, direction, rotate }) => {
  const list = [...items, ...items, ...items, ...items, ...items, ...items];
  return (
    <div
      className={`absolute left-1/2 top-1/2 w-[140%] -translate-x-1/2 -translate-y-1/2 py-4 overflow-hidden ${
        dark ? "bg-[#0b0b0b] text-white" : "bg-[#ff4d17] text-white"
      }`}
      style={{ transform: `translate(-50%,-50%) rotate(${rotate}deg)` }}
    >
      <div
        className={`flex w-max ${direction === "left" ? "animate-marquee-left" : "animate-marquee-right"}`}
        style={{ "--marquee-duration": "26s" }}
      >
        {list.map((item, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-cal text-2xl md:text-4xl px-6 whitespace-nowrap">{item}</span>
            <X size={20} className="opacity-80" />
          </div>
        ))}
      </div>
    </div>
  );
};

const MarqueeBands = () => {
  return (
    <section className="relative h-[280px] md:h-[340px] bg-[#ececec] overflow-hidden">
      <Band items={marqueeBottomItems} dark direction="left" rotate={-6} />
      <Band items={marqueeTopItems} direction="right" rotate={6} />
    </section>
  );
};

export default MarqueeBands;
